import { FilterTypeKey, FilterType, IEntityFilter, INumberFilter } from '../../components/filters-menu/filters';
import { Statuses } from '../../enums/status';

export const bidderAdvertiserFilters = new Map<FilterTypeKey, FilterType>([
	['entityFilters', {} as IEntityFilter],
	[
		'numberFilters',
		{
			id: {
				columnName: 'id',
				cellKey: 'id',
				isClientFilter: true,
			},
			dailyMoneySpent: { columnName: 'Daily Money Spent', isClientFilter: true, cellKey: 'dailyMoneySpent' },
			dailyMoneyEarn: { columnName: 'Daily Money Earn', isClientFilter: true, cellKey: 'dailyMoneyEarn' },
			totalBudget: { columnName: 'Total Budget', isClientFilter: true, cellKey: 'totalBudget' },
			totalMoneySpent: { columnName: 'Total Money Spent', isClientFilter: true, cellKey: 'totalMoneySpent' },
			totalMoneyEarn: { columnName: 'Total Money Earn', isClientFilter: true, cellKey: 'totalMoneyEarn' },
			priority: { columnName: 'Priority', isClientFilter: true, cellKey: 'priority' },
		} as INumberFilter,
	],

	[
		'stringFilters',
		{
			name: { columnName: 'Name', isClientFilter: true, cellKey: 'name' },
		},
	],
	[
		'booleanFilters',
		{
			shouldReceiveL1: { columnName: 'Should Receive L1', isClientFilter: true, cellKey: 'shouldReceiveL1' },
			useEnhancedBlackList: { columnName: 'Use Enhanced Black List', isClientFilter: true, cellKey: 'useEnhancedBlackList' },
		},
	],

	[
		'enumFilters',
		{
			status: {
				columnName: 'Status',
				cellKey: 'status',
				enumOptions: [
					{ value: Statuses.Active, label: 'Active' },
					{ value: Statuses.Paused, label: 'Paused' },
					{ value: Statuses.NoBalance, label: 'No Balance' },
					{ value: Statuses.New, label: 'New' },
					{ value: Statuses.Ended, label: 'Ended' },
				],
				deletable: true,
			},
		},
	],
]);
